import React, { useEffect, useRef, useState } from "react";
import api from "../../utils/api";
import { S_SKU, webStorage } from "../../utils/webStorage";
import { multiBindConsents } from "../../services/consentService";
import { saveOrder } from "../../services/orderService";
import url from "url";
import querystring from "querystring";
import { appendQuery } from "../../utils/urlHelper";
import config from "../../temp/config";
import { _3dsStatus } from "../../utils/lynkco-constants";
import HeroGradient from "../hero-gradient";
import AccordionWrapper from "../../elements/accordion-wrapper";
import Summary from "../summary";
import CardInfo from "../card-info";
import PreSalesBillingInfo from "../presales-billing-info";
import { getAddressList, savePreSalesAddress } from "../../services/checkoutService";

const PreSalesCheckoutViewOnLine = ({ lang, hero, newAddressLabel, billingInfo, becomeAMemberSummary, cardInfo, summary, user, confirmationUrl, onSummaryCallback, onPayment, onError, match }) => {
  const billingInfoRef = useRef();
  const [addressList, setAddressList] = useState([]);
  const [noAddress, setNoAddress] = useState(false);
  useEffect(() => {
    loadAddressList();
  }, []);
  const loadAddressList = async () => {
    let _addressList = await getAddressList(newAddressLabel.value);
    setNoAddress(_addressList.length === 0);
    setAddressList(_addressList);
  };
  const addAddress = async address => {
    const newAddressList = await getAddressList(newAddressLabel.value);
    const addedItem = newAddressList.find(x => addressList.every(y => x.value !== y.value));
    addedItem.address.firstName = address.firstName;
    addedItem.address.lastName = address.lastName;
    addedItem.isNew = true;
    setNoAddress(newAddressList.length === 0);
    setAddressList(newAddressList);
    return addedItem;
  };
  const updateAddress = async () => {
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const removeAddress = address => {
    const index = addressList.findIndex(x => x === address);
    addressList.splice(index, 1);
    const newAddressList = addressList.slice();
    const newAddr = newAddressList.find(x => x.isNew);
    if (newAddr) {
      delete newAddr.isNew;
    }
    setAddressList(newAddressList);
  };
  const onSubmit = async ({ isValid: isCardInfoValid, paymentToken, paymentRegistrationToken, bankCardId, isSavePayment }) => {
    try {
      const sku = webStorage.get(S_SKU);
      const { isValid: isBillingInfoValid, formData: billingFormData } = billingInfoRef.current.validateForm();
      if (isBillingInfoValid && isCardInfoValid) {
        await multiBindConsents(
          user?.email,
          billingFormData.countryId,
          cardInfo.termsAndConditions?.map(t => t.id)
        );
        //TODO: Call Create Leads
        const skuQtyVoList = [
          {
            qty: 1,
            skuId: sku
          }
        ];
        const billingInfoData = {
          billingFirstName: billingFormData.firstName,
          billingLastName: billingFormData.lastName,
          billingEmail: user?.email,
          billingCountryCode: billingFormData.countryCode,
          billingPhone: `${user?.mobileNoCountryCode}${user?.mobileNo}`,
          billingAddress1: billingFormData.street,
          billingAddress2: billingFormData.apartment,
          billingPostalCode: billingFormData.postalCode,
          billingCity: billingFormData.city,
          billingCountry: billingFormData.country,
          billingCountryId: billingFormData.countryId
        };
        const {
          obj: { orderNo, orderId }
        } = await saveOrder(billingInfoData, skuQtyVoList);

        const orderLink = url.parse(confirmationUrl.value?.href);
        const query = querystring.parse(orderLink.query);
        const redirect = decodeURIComponent(query.redirect);
        let returnUrl = decodeURIComponent(
          appendQuery(confirmationUrl.value.href, {
            ...query,
            redirect: encodeURIComponent(
              appendQuery(redirect, {
                orderNo: orderNo,
                orderId: orderId
              })
            )
          })
        );
        // let returnUrl = confirmationUrl.value?.href;
        if (!/^https?/i.test(returnUrl)) {
          returnUrl = config.sitecoreApiHost + returnUrl;
        }
        const payBody = {
          orderNo: orderNo, //订单号
          isRemember: isSavePayment ? 1 : 0, //此项目勾选可以保存本次paymenttoken
          returnUrl: returnUrl
        };
        if (paymentRegistrationToken) {
          Object.assign(payBody, {
            paymentRegistrationToken,
            bankCardId,
            isRemember: 0
          });
        } else {
          Object.assign(payBody, {
            paymentToken
          });
        }
        const {
          obj: { redirectUrl, status, payMethodName }
        } = await api.order.pay(null, payBody);
        if (isSavePayment) {
          await savePreSalesAddress(billingFormData);
        }
        switch (status) {
          case _3dsStatus.pendingHasLink:
            onPayment && onPayment(redirectUrl, payMethodName);
            measurements();
            break;
          case _3dsStatus.successNoLink:
            onPayment && onPayment(returnUrl, payMethodName);
            measurements();
            break;
          case _3dsStatus.failed:
            onError && onError({ code: _3dsStatus.failed });
            break;
          default:
            break;
        }
      }
    } catch (ex) {
      onError && onError(ex);
      console.error(ex);
    }
  };

  const measurements = () => {
    if (becomeAMemberSummary && becomeAMemberSummary.color && becomeAMemberSummary.engine && becomeAMemberSummary.financing) {
      let dataLayer = window.dataLayer || [];
      let color = becomeAMemberSummary.color?.preSelectValue?.value;
      let engine = becomeAMemberSummary.engine?.preSelectValue?.value;
      let financing = becomeAMemberSummary.financing?.preSelectValue?.value;

      dataLayer.push({
        event: "payDepositForm",
        eventCategory: "membership pay deposit",
        eventAction: "form submitted",
        eventLabel: `${color} | ${engine} | ${financing}`
      });
    }
  };
  const billingInfoProps = {
    fields: billingInfo.fields,
    ref: billingInfoRef,
    addressList,
    addAddress,
    updateAddress,
    removeAddress,
    loadAddressList,
    noAddress
  };
  const summaryProps = {
    ...summary,
    match: match,
    callback: ({ color, engine }) => {
      let becomeAMemberSummary = {
        engine: {
          preSelectValue: engine
        },
        color: {
          preSelectValue: color
        }
      };
      onSummaryCallback && onSummaryCallback(becomeAMemberSummary);
    }
  };

  return (
    <section className="pre-sales-checkout grid">
      <HeroGradient {...hero} />
      {summary && (
        <div className="summary-container-mobile">
          <AccordionWrapper
            heading={{
              ...summaryProps.text.heading,
              typographyClass: "tpye-link"
            }}
          >
            <Summary
              {...{
                ...summaryProps,
                text: { ...summaryProps.text, heading: null },
                match: match
              }}
            />
          </AccordionWrapper>
        </div>
      )}

      <PreSalesBillingInfo {...billingInfoProps} />
      <CardInfo
        {...{
          ...cardInfo,
          user,
          lang,
          onSubmit
        }}
      />
      {summary && (
        <div className="summary-container">
          <Summary {...summaryProps} />
        </div>
      )}
    </section>
  );
};
export default PreSalesCheckoutViewOnLine;
